import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import utils from './lib/utils.js'
import {configs as config} from './configs'

Vue.use(Vuex)

const sessionStorageKeys = [
  'qiniuToken',
  'qiniuTokenExpires',
  'cacheDefaultCategory'
]
sessionStorageKeys.forEach(item => {
  if (sessionStorage.getItem(item)) {
    if (item === 'cacheDefaultCategory') {
      state[item] = JSON.parse(sessionStorage.getItem(item))
    } else {
      state[item] = sessionStorage.getItem(item)
    }
  }
})

let userInfo = JSON.parse(utils.getCookie('user-info')) || null
let sessionId = utils.getCookie('sessionid') || null

const state = {
  userInfo: userInfo,
  sessionId: sessionId || null,
  qiniuToken: null, // 七牛上传图片 token
  qiniuTokenExpires: null, // 七牛 token 过期时间
  cacheDefaultCategory: {} // 类别默认项缓存
}

const getters = {
  isAuthenticated: state => !!state.userInfo
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
  },
  REMOVE_TOKEN (state) {
    state.token = null
  },
  SET_SESSION_ID (state, sessionId) {
    state.sessionId = sessionId
  },
  REMOVE_USER_INFO (state) {
    state.userInfo = null
  },
  REMOVE_SESSION_ID (state) {
    state.sessionId = null
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  AUTH_REQUEST ({commit, dispatch}, user) {
    commit('SET_TOKEN', '')
    return new Promise((resolve, reject) => {
      axios({
        url: config.API.login,
        method: 'POST',
        data: {
          username: user.username,
          password: user.password,
          remember_me: user.checked ? 1 : 0
        }
      })
        .then(res => {
          if (res.data.result === 'failed') {
            reject(new Error(res.data.message))
          } else {
            const dataObj = JSON.stringify(res.data.data)
            let expired = 1000
            // expired = res.data.data.expire_at * 1000
            // if (user.checked) {
            //   expired = 1000
            // } else {
            //   expired = 1
            // }
            utils.setCookie('user-info', dataObj, expired)
            utils.setCookie('sessionid', res.data.sessionid, expired)
            utils.setCookie('JSESSIONID', res.data.sessionid, expired)
            commit('SET_USER_INFO', res.data.data)
            commit('SET_SESSION_ID', res.data.sessionid)
            resolve(res)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  LOGOUT ({commit, dispatch}, $router) {
    let url = config.API.logout
    utils.deleteCookie('user-info')
    utils.deleteCookie('sessionid')
    utils.deleteCookie('JSESSIONID')
    commit('REMOVE_USER_INFO')
    commit('REMOVE_SESSION_ID')
    $router.push('/login')
    axios.get(url, {withCredentials: true})
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store.js